<template>
  <section>
    <div class="modal-body">
      <ul class="nav nav-tabs" role="tablist" id="network-tabs">
        <li v-for="(item, key) in interfaces" :key="key" class="nav-item">
          <a class="nav-link" data-toggle="tab" :href="`#m_tabs_1_${key}`" @click="changeTab(key)">
            <i class="la la-cube m--font-warning"></i>
            {{ item }}
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div v-for="(item, key) in networks" :key="key" class="tab-pane" :id="`m_tabs_1_${key}`" role="tabpanel">
          <form :name="`form-${key}`" :id="`form-${item.interface}`" :data-vv-scope="`form-${key}`">
            <div class="form-group m-form__group" :class="{'has-danger': errors.has(`form-${key}.config_type`)}">
              <label for="config_type">{{ 'network_type' | translate | capitalize }}</label>
              <select v-model="networks[key].config_type" :name="`config_type_${key}`" :id="`config_type_${key}`" class="form-control m-bootstrap-select m_selectpicker" :title="'select_network_type' | translate | capitalize" v-validate="''">
                <option v-for="network_type in network_types" :key="network_type.value" :value="network_type.value">{{ network_type.name | translate | capitalize }}</option>
              </select>
              <span v-show="errors.has(`form-${key}.config_type`)" class="m-form__help m--font-danger"> {{ errors.first(`form-${key}.config_type`) }} </span>
            </div>
            <div class="form-group m-form__group row">
              <div v-if="networks[key].config_type == 2" class="col-lg-4" :class="{ 'has-danger': errors.has(`form-${key}.ip_address`) }">
                <label for="ip_address">{{'ip_address' | translate | capitalize }}</label>
                <input type="text" id="ip_address" v-model="networks[key].ip_address" name="ip_address" :placeholder="'enter_ip_address' | translate | capitalize" class="form-control m-input" v-validate="'required|ip'">
                <span v-show="errors.has(`form-${key}.ip_address`)" class="m-form__help m--font-danger"> {{ errors.first(`form-${key}.ip_address`) }} </span>
              </div>
              <div v-if="networks[key].config_type == 2" class="col-lg-4" :class="{ 'has-danger': errors.has(`form-${key}.netmask`) }">
                <label for="">{{'netmask' | translate | capitalize }}</label>
                <input type="text" id="netmask" v-model="networks[key].netmask" name="netmask" :placeholder="'enter_netmask' | translate | capitalize" class="form-control m-input" v-validate="'required|ip'">
                <span v-show="errors.has(`form-${key}.netmask`)" class="m-form__help m--font-danger"> {{ errors.first(`form-${key}.netmask`) }} </span>
              </div>
              <div v-if="networks[key].config_type == 2" class="col-lg-4" :class="{ 'has-danger': errors.has(`form-${key}.gateway`) }">
                <label for="gateway">{{ 'gateway' | translate | capitalize }}</label>
                <input type="text" id="gateway" v-model="networks[key].gateway" name="gateway" :placeholder="'enter_gateway' | translate | capitalize" class="form-control m-input" v-validate="'required|ip'">
                <span v-show="errors.has(`form-${key}.gateway`)" class="m-form__help m--font-danger"> {{ errors.first(`form-${key}.gateway`) }} </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      
      <button type="button" class="btn btn-secondary" @click="resetForm" id="btn-cancel">
        {{ 'close' | translate | capitalize }}
      </button>
      <button type="button" class="btn btn-primary" @click="submitForm">
        {{ 'submit' | capitalize }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      active: 0,
      interfaces: [],
      networks: [],
      update_tab: false,
      network_types: [
        { name: 'dynamic', value: '1' },
        { name: 'static', value: '2' }
      ]
    }
  },
  computed: {
    ...mapGetters({modal: 'getStatusNetworkModal'})
  },
  methods: {
    ...mapActions(['retrieveNetworks', 'registerNetworks', 'rewriteNetworks', 'setStatusNetworkModal']),
    changeTab (key) {
      console.log(event)
      this.$validator.validateAll(`form-${this.active}`)
        .then((result) => {
          if (result) {
            this.update_tab = true
            this.active = key
          }
          const id = `.nav-tabs a[href="#m_tabs_1_${this.active}"]`
          console.log(id)
          window.$(id).tab('show')
        })
    },
    resetForm () {
      window.$('#network_modal').modal('hide')
      this.$validator.reset()
      this.setStatusNetworkModal(false)
    },
    submitForm () {
      const self = this
      this.$validator.validateAll(`form-${this.active}`)
        .then((result) => {
          if (result) {
            this.registerNetworks(this.networks.filter((element) => element.config_type !== ''))
              .then((res) => {
                const results = res.data.results
                results.forEach(function (element) {
                  if (!element.error) {
                    self.$toast('register_network_message')
                  } else {
                    self.$toast('register_network_error', 4)
                  }
                })
                this.rewriteNetworks()
                  .then((res) => {
                    self.resetForm()
                    self.$toast('restart_network_interfaces')
                  })
                  .catch((err) => {
                    console.log(err)
                    this.$toast('register_network_error', 4)
                  })
              })
              .catch((err) => {
                console.log(err)
                this.$toast('register_network_error', 4)
              })
          }
        })
    }
  },
  created () {
    this.$spinner.show()
    this.retrieveNetworks()
      .then((res) => {
        const networks = res.data.networks
        const interfaces = res.data.interfaces
        const self = this
        interfaces.forEach(function (element, index) {
          const network = networks.find((network) => network.interface === element)
          if (network) {
            self.networks[index] = network
          } else {
            self.networks[index] = { ip_address: '', netmask: '', gateway: '', interface: element, config_type: '' }
          }
        })
        this.interfaces = interfaces
        window.$('.m_selectpicker').selectpicker('refresh')
        this.$spinner.remove()
        const $ = window.$
        this.$validator.reset()
        this.$nextTick(() => {
          const self = this
          $('#network-tabs').tab('show')
          $('.nav-tabs a[href="#m_tabs_1_0"]').tab('show')
          $('.m_selectpicker').selectpicker('refresh')
          $('[data-toggle="tab"]').on('show.bs.tab', function (e) {
            if (self.update_tab) {
              self.update_tab = false
              return
            }
            e.preventDefault()
          })
        })
      })
      .catch((err) => {
        console.log(err)
        this.$spinner.remove()
      })
  },
  watch: {
    modal () {
      this.$validator.reset()
      const $ = window.$
      this.$nextTick(() => {
        $('.m_selectpicker').selectpicker('refresh')
      })
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Network.vue